import { useTakeoverContext } from 'modules/sendingPlatforms/contexts';
import { PanelSize, TakeOver } from 'ui/takeOver';
import { TakeoverBody, TakeoverFooter, TakeoverNavBar, TakeoverOverlay } from './components';

export const BusinessProfilesTakeover = () => {
  const { isOpen, closeTakeover } = useTakeoverContext();

  return (
    isOpen && (
      <TakeOver
        Footer={<TakeoverFooter />}
        NavBar={<TakeoverNavBar />}
        onClose={closeTakeover}
        Overlay={<TakeoverOverlay />}
        size={PanelSize.Medium}
      >
        <TakeoverBody />
      </TakeOver>
    )
  );
};
